export enum ConnectionTypeEnum {
	includeOptions,
	includeOptionsAndDescriptions,
	includeNewOptions,
	noOptions
}
